export const SUBDOCUMENT_TYPES = {
  consentimiento: [
    { label: 'Internación', value: 'consentimiento_internacion' },
    { label: 'Quirúrgico', value: 'consentimiento_quirurgico' },
  ],
  datos_paciente: [
    { label: 'Varios(*)', value: 'varios' },
    { label: 'DNI', value: 'dni' },
    { label: 'Boleta Sueldo', value: 'boleta_sueldo' },
    { label: 'Reglamento', value: 'reglamento' },
    { label: 'Bono', value: 'bono' },
    { label: 'Informes de Derivaciones', value: 'informes_derivaciones' },
    { label: 'Estudios', value: 'estudios' },
    { label: 'Autorizaciones', value: 'autorizaciones' },
    { label: 'Alta Voluntaria', value: 'alta_voluntaria' },
    { label: 'Otro', value: 'otro' },
  ],
  estudio_cardiologico: [
    { label: 'Cardíaco', value: 'cardiaco' },
    { label: 'Vaso de Cuello', value: 'vaso_cuello' },
    { label: 'Otro', value: 'otro' },
  ],
  laboratorio: [
    { label: 'Test COVID', value: 'test_covid' },
    { label: 'Test Influenza', value: 'test_influenza' },
    { label: 'Cultivo', value: 'cultivo' },
    { label: 'Hisopado', value: 'hisopado' },
    { label: 'Otro', value: 'otro' },
  ],
  protocolo: [
    { label: 'Quirúrgico', value: 'quirurgico' },
    { label: 'Anestésico', value: 'anestesico' },
    { label: 'Otro', value: 'otro' },
  ],
  imagenes: [
    { label: 'Imagen', value: 'imagen' },
    { label: 'Informe', value: 'informe' },
    { label: 'Informe Externo', value: 'informe_externo' },
    { label: 'Otro', value: 'otro' },
  ],
  pedidos_autorizaciones: [
    { label: 'Aviso de Internación', value: 'aviso_internacion' },
    { label: 'Autorización Pedida', value: 'autorizacion_pedida' },
    { label: 'Pedido del Médico', value: 'pedido_medico' },
    { label: 'QX Programada', value: 'qx_programada' },
    { label: 'Pedido de Prórroga', value: 'pedido_prorroga' },
    { label: 'QX Urgencia', value: 'qx_urgencia' },
    { label: 'Medicamento', value: 'medicamento' },
    { label: 'Medicamento Alto Costo', value: 'medicamento_alto_costo' },
    { label: 'Otro', value: 'otro' },
  ],
  otro: [
    { label: 'Otro', value: 'otro' },
  ]
};